<script>

import { mapGetters, mapActions } from 'vuex'
export default {
  name: "alert-message",
  props: {
    isEditMode: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    useCookies: {
      type: Boolean,
      required: false,
      default: () => true,
    },
    id: {
        type: String,
        required: true,
    }
  },
  data() {
    return {
      dismissedIds: []
    }
  },
  methods: {
    ...mapActions('auth', ['dismissAlertMessage']),
    dismissAlert() {
      this.dismissAlertMessage(this.id);
    },
  },
  computed: {
    ...mapGetters('auth', ['getDismissedIds']),
    isVisible() {
      return this.getDismissedIds.indexOf(this.id) > -1 && !this.isEditMode;
    }
  },
  render() {
    return this.$scopedSlots.default({
      dismiss: this.dismissAlert,
      visible: this.isVisible,
    });
  },
};
</script>